export default "__VITE_ASSET__DSIxZ9Vt__"